import { useEffect, useState,useRef } from 'react';
import './App.css';
import Dashboard from './Component/Dashboard';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Billing from './Component/Billing/Billing';
import { ConfirmProvider } from './Component/ConfirmationToaster';
import Login from './Component/login';
import { isNotValidNullUndefile } from './control/Constant';
import { Services } from './network/Services';
import { useNavigate } from 'react-router-dom';
import { $CommonServiceFn } from './network/Services';
import AoUrl, { AoLoginUrl } from './network/url';
import Toaster from './Component/Toaster';
import Loader from './Component/Loader';
import config from './config.json'
import { decodeFromUrlSafeBase64 } from './network/helper';
import TopHead from './Component/TopHead';
import FeedBack from './Component/FeedBack/FeedBack'


const getQueryValue = (param) => new URLSearchParams(window.location.search).get(param);
function App(props) {


  const [authToken,setAuthToken] = useState()
  const [isModal,setIsModal] = useState(false)
  const [email,setEmail] = useState('')
  const [cameFromGateway, setCameFromGateWay] = useState(false);
  const [cameFromIntake, setCameFromIntake] = useState(false);
  const [showOtp,setShowOtp] = useState(false)
  const token = getQueryValue("token") || "";
  const dataQuery = getQueryValue("moConId") || "";
  const decodedData = {paymnetFromIntake: dataQuery == '' ? 'false':'true'}
  const invoiceRef = useRef(null);
  const [timer, setTimer] = useState(false);
  const [userDetails, setUserDetails] = useState({});
  const [disabled, setDisabled] = useState(true);
  const [otpError, setOtpError] = useState('')
  const [otpDetails,setOtpDetails] = useState()
  const [otpVerified,setOtpVerified] = useState()
  const [isUserRegistration,setIsuserRegistration] = useState(false)
  const startingTabIndex =  0;
  const [toast, setToast] = useState(null);
  const [useLoader, setuseLoader] = useState(false)
  const [showRegistreBtn,setShowRegistreBtn] = useState(false)


  useEffect(() =>{
    let AuthTokens = sessionStorage.getItem('AuthToken');
    let isOtpVarified = JSON.parse(sessionStorage.getItem('isOtpVarified'));
    let userRegistration = JSON.parse(sessionStorage.getItem('userRegistration'));
     let userRegistred = JSON.parse(sessionStorage.getItem('userRegistred'));
     setIsuserRegistration(userRegistration || userRegistred)
     setOtpVerified(isOtpVarified)
     setAuthToken(AuthTokens)
      if((!AuthTokens && !token) && (isOtpVarified !== true) && (userRegistration !== true) && (userRegistred !== true) && (config?.isLogin == true)){
        // const newUrl = 'https://aologinuat.agingoptions.com/Account/SignIn';
        // window.location.replace(newUrl)
          setIsModal(true)
          return
        }
      },[])

  useEffect(() => {
    let loginTextCasePassed = false;
    const _authTokens = sessionStorage.getItem('AuthToken');
    const _cameFromIntake = decodedData?.paymnetFromIntake === "true";
    const _cameFromGateway = sessionStorage.getItem("isCameFromPaymentGateWay") === "true";

    // With Login
    if(isNotValidNullUndefile(_authTokens) || (window.location.pathname == "/login")) loginTextCasePassed = true;
    // From Intake
    else if(_cameFromIntake || cameFromIntake) {
      setCameFromIntake(true);
      loginTextCasePassed = true;
    }
    // From Payment Gateway
    else if(_cameFromGateway || cameFromGateway) {
      setCameFromGateWay(true);
      loginTextCasePassed = true;
    }
    // Direct Access
    else window.location.replace(AoLoginUrl);

  }, [])


  const handleChanges =(e)=>{
     sessionStorage.setItem("isClient",true);
   setEmail(e)
  }

  const handleSubmit = () => {
    setuseLoader(true)
    const strictEmailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const isStrictValidEmail = (email) => strictEmailRegex.test(email);
    if (isStrictValidEmail(email)) {
        Services?.getUserDetailByEmailId(email).then((res) => {
        if (res?.data.length > 0) {
          const hasRole = res?.data[0]?.roleDetails?.some(item => [1, 9, 10].includes(item.roleId));
          if(hasRole == true){
            setUserDetails(res?.data[0])
            const postData = {
              "createdBy": res?.data[0]?.userId,
              "otpSendMedium": 4,
              "subtenantId": res?.data[0]?.subtenantId,
              "otpType": "USER_ACTIVATION"
            }
            $CommonServiceFn.InvokeCommonApi("POST", AoUrl.postSendOtp, postData, (response, errordata) => {
              if (response) {
              setOtpDetails(response?.data?.data)
              setShowOtp(true)
              timerFunction(120);
               setuseLoader(false)
              inputsRef.current[1].focus();
              }else{
                 setuseLoader(false)
              }
            }
            );
          }else{
             setToast({ message: 'This user have not client role', type: "error" });
             setuseLoader(false)
             setEmail('')
          }



        }else{
          setToast({ message: 'This email is not registered', type: "error" });
          setShowRegistreBtn(true)
          setuseLoader(false)
          setuseLoader(false)
        }
      })

    } else {
    setuseLoader(false)
    setToast({ message: 'Enter a valid email', type: "error" });
    setEmail('')
    }

  }

    function onHandle(event) {
      const newOtp = otp.join("")
     if(newOtp.length == 6){
       onOtpSubmit(newOtp);
       return true;
     }else{
      setToast({ message: 'Please enter the otp', type: "error" });
     }
  }


    const onOtpSubmit = (gettedvalue) => {
    const submitData = {
      id: parseInt(otpDetails.id),
      createdBy: userDetails.userId,
      otp: parseInt(gettedvalue),
      signUpPlateform: userDetails.signUpPlatform,
    };
    if (disabled == true) { // It should be done by backend
      setuseLoader(true)
      $CommonServiceFn.InvokeCommonApi("POST", AoUrl.postOtpData, submitData, (response, errordata) => {
        if (response) {
          sessionStorage.setItem("SessPrimaryUserId",userDetails?.userId);
          sessionStorage.setItem("SubtenantId", userDetails.subtenantId);
          sessionStorage.setItem("subtenantName", userDetails.subtenantName);
          sessionStorage.setItem("isOtpVarified", true);
          if(userDetails?.subtenantId == 3){
            sessionStorage.setItem("companyName", 'aging_options');
          }else{
            sessionStorage.setItem("companyName", 'life_point_law');
          }
          window.location.replace('/')
          setuseLoader(false)
        } else if (errordata) {
           setToast({ message: 'Invalid Otp.', type: "error" });
           setOtp(["", "", "", "", "", ""])
           setuseLoader(false)

        }
      }
      );
    } else {
      setToast({ message: 'OTP Expired', type: "error" });
      setOtp(["", "", "", "", "", ""])
    }
  };





    const handleTimer = async (e) => {
    timerFunction(120);
    document.getElementById("Otpbox").reset()
    setOtp(["", "", "", "", "", ""])
    setDisabled(true);

    const inputData = {
      createdBy: userDetails.userId,
      otpSendOn: otpDetails?.otpSendOn,
      otpSendMedium: 4,
      id: parseInt(otpDetails.id),
      otpType: "TWOFACTORAUTHENTICATION",
    };

      if (inputData.createdBy !== undefined && inputData.otpSendOn !== undefined && inputData.otpSendMedium !== undefined && inputData.id !== undefined) {
        setuseLoader(true);
        $CommonServiceFn.InvokeCommonApi("POST", AoUrl.postResendOtp, inputData, (response) => {
          setuseLoader(true)
          if (response) {
            setToast({ message: 'OTP has been sent to your email address and phone number.', type: "success" });
            otpDetails.id = response.data.data.id
            setOtpDetails(otpDetails)
            setuseLoader(false)
          } else {
            setToast({ message: 'Something went wrong. Try again later.', type: "error" });
            setuseLoader(false)
          }
        }
        );
      } else {
        setToast({ message: 'Something went wrong. Try again later.', type: "error" });
      }
  };

 let timerOn = true;

  function timerFunction(remaining) {
    setTimer(remaining);
    sessionStorage.setItem('remainingTime', remaining);
    remaining -= 1;

    if (remaining >= 0 && timerOn) {
      setTimeout(function () {
        timerFunction(remaining);
      }, 1000);
      return;
    }
    setDisabled(false);
  }








  const key = () => { };




  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const inputsRef = useRef([]);

  const handleChange = (value, index) => {
    if (!/^\d*$/.test(value)) return; // Allow only digits

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    // Move to next input if a digit is entered
    if (value && index < inputsRef.current.length - 1) {
      inputsRef.current[index + 1].focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputsRef.current[index - 1].focus();
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pasteData = e.clipboardData.getData("text").slice(0, 6);
    if (!/^\d+$/.test(pasteData)) return;

    const newOtp = pasteData.split("");
    setOtp(newOtp);

    // Focus last filled field
    inputsRef.current[Math.min(pasteData.length - 1, 5)].focus();
  };


 const handleRegistration =()=>{
       const subtinent = getQueryValue('subtinentId')
       sessionStorage.setItem("SubtenantId", subtinent || 742);
       sessionStorage.setItem("userRegistration",true);
       sessionStorage.setItem("companyName", 'life_point_law');
       setIsModal(false)
       window.location.replace('/')
 }
  const handleLogin = () => {
    const newUrl = AoLoginUrl;
    window.location.replace(newUrl)
  }




  return (
    <>
    <ConfirmProvider>
      {isNotValidNullUndefile(authToken) && <TopHead queryData={decodedData} page={"Assignrole"} />}
      <BrowserRouter>
         <Routes>
          <Route path="/login" element={<Login />} />
         {(isNotValidNullUndefile(authToken) || (otpVerified == true || isUserRegistration == true || config?.isLogin == false)) && <>
           <Route path="/" element={<Dashboard authToken={authToken}/>}/>
          <Route path="/Billing" element={<Billing />} />

          </>}

        </Routes>
      {<FeedBack fromLegalPage={true}  classNameLocal="positionFeedBackButton"/>}
      </BrowserRouter>

    </ConfirmProvider>
      {isModal &&
         <>
          {toast && ( <Toaster message={toast?.message} type={toast?.type} onClose={() => setToast(null)}/>)}
            {useLoader &&  <Loader useLoader={useLoader} />}
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white w-full max-w-2xl rounded-lg shadow-lg">


            <div className="flex flex-wrap justify-between items-center px-6 py-4 border-b">
              <h4 className="text-lg font-bold">Client Verification</h4>
              {/* <h4 className="text-sm md:text-base font-medium cursor-pointer">Staff Login</h4> */}
              <button className="text-white px-3 py-1 rounded text-sm" style={{backgroundColor:"#720d21"}} onClick={handleLogin}>Staff Login</button>
            </div>

            <div className="p-4">
              <div ref={invoiceRef} className="max-w-4xl mx-auto p-4 bg-white shadow rounded overflow-auto" style={{ maxHeight: "30rem" }}>

                <div />


                {!showOtp ? <div className="w-full md:w-[49%] m-auto">
                <h5 className="text-lg font-bold text-center">Verify by Email</h5>
                  <h3 className="block text-sm font-medium text-gray-700 mb-1">Email*</h3>
                  <input
                    className={`w-full px-3 py-2 border border-gray-300 rounded-md`}
                    placeholder="Enter your Email"
                    value={email}
                    onChange={(e) => handleChanges(e.target.value)}
                  />
                  <div className='flex justify-between'>
                    {showRegistreBtn ? (
                      <a href="/" onClick={handleRegistration} className="mt-4 underline text-blue-600 hover:text-blue-800"
                        style={{ marginLeft: "5px" }}>Register Here</a>) : <div></div>}
                    <button className="text-white px-3 py-1 rounded text-sm mt-4" style={{ backgroundColor: "#720d21" }} onClick={handleSubmit}>Verify</button>
                  </div>

                </div> :
                  <>

                    <div id="Otp">
                      <form
                        id="Otpbox"
                        className="flex items-center justify-center"
                        onSubmit={(e) => e.preventDefault()}
                      >
                        <div className="w-full max-w-md p-6 bg-white shadow-md rounded-md">
                          <div className="flex justify-center mb-4">
                            <img src="/message.svg" alt="message" />
                          </div>

                          <p className="text-xl font-semibold text-center mb-2">
                            Check your email & contact number
                          </p>

                          <div className="mb-4">
                            <label className="block text-gray-700 font-medium mb-1">
                              Enter Code
                            </label>

                            <div
                              id="otp"
                              className="flex items-center justify-between gap-2 mt-2"
                              onPaste={handlePaste}
                            >
                              {otp.map((digit, index) => (
                                <div key={index} className="w-10 h-12">
                                  <input
                                    type="text"
                                    value={digit}
                                    maxLength="1"
                                    onChange={(e) => handleChange(e.target.value, index)}
                                    onKeyDown={(e) => handleKeyDown(e, index)}
                                    ref={(el) => (inputsRef.current[index] = el)}
                                     autoFocus={index == 0}
                                    className="w-full h-full text-center text-xl border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                                  />
                                </div>
                              ))}
                            </div>
                          </div>

                          <div className="mb-4">
                            <button
                              type="submit"
                              onClick={onHandle}
                              className="w-full  hover:bg-blue-700 text-white font-semibold py-2 px-4 rounded"
                              style={{backgroundColor:"#720d21"}}
                            >
                              Verify OTP
                            </button>
                          </div>
                                <p className="text-center text-lg text-gray-600 my-3" id="timer">
                            {timer > 0 ? timer : ""}
                          </p>

                          <div className="text-center text-sm text-gray-600">
                            <p>
                              Don’t receive the email?{' '}
                              <button
                                id="resend"
                                disabled={disabled}
                                tabIndex={startingTabIndex + 8}
                                onClick={handleTimer}
                                className={`underline ${disabled ? 'text-gray-400 cursor-not-allowed' : 'text-blue-600 cursor-pointer'
                                  }`}
                              >
                                Click to resend
                              </button>
                            </p>
                          </div>
                        </div>
                      </form>
                    </div>


                  </>}

              </div>

            </div>


          </div>
        </div>
         </>
        }
    </>

  );
}

export default App;
